Service = App.loadClass 'core::Angular/Service'

class exports.TypeHelpService extends Service
    constructor: (@http, @rootScope) ->
        @loadTypeHelp()


    loadTypeHelp: () =>
        @typeHelp = {}

        @typeHelp.Yield =
            'This data is generated by your equipment. It reflects the topline
            revenue of each piece of land and is proprietary to your farm.'

        @typeHelp.AsApplied =
            'This data records previous seeding, fertilizer or spraying operations.
            It is generated by your equipment or the third party responsible for
            applying your fertilizer, for example. It is valuable data that is
            unique to each farm.'

        @typeHelp.AsPlanted =
            'This data is generated by your planter.  It is valuable for analyzing seed
             performance, if you also import yield maps for each field.'

        @typeHelp.Prescriptions =
            'These maps define your plan for future variable rate seeding,
            fertilizer or spraying operations. They could be created by you or a
            third party using a different mapping system.'

        @typeHelp.Infrastructure =
            'These maps outline your tile lines and irrigation infrastructure.
            This data may have been generated by you or the third party that
            installed your equipment.'

        @typeHelp.SoilSampling =
            'Upload soil sampling locations or contour maps that were created
            by a third party based upon the lab results associated with your soil
            samples and locations.'

        @typeHelp.ManagementZone =
            'Supports upload of previously-created management zones such as
            Productivity.'


    showTypeHelp: (type) =>
        type = type.replace(/\s+/g, '').replace('-', '')
        return @typeHelp[type] ? ''
